import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import JSXParser from 'react-jsx-parser';
import { blogPosts } from '../data/contant';
import Navbar from './Navbar';
import { motion } from 'framer-motion';

const ServiceDetail = () => {
  const { serviceLink } = useParams();
  const navigate = useNavigate();

  const post = blogPosts.find((p) => p.link === `/service/${serviceLink}`);
  const otherPosts = blogPosts.filter((p) => p.link !== `/service/${serviceLink}`);

  useEffect(() => {
    if (!post) {
      navigate('/services');
    }
  }, [post, navigate]);

  if (!post) return null;

  return (
    <>
      <Navbar />
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-8">
            {/* Main Content */}
            <motion.div
              className="md:w-3/4"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              <h2 className="text-3xl font-bold mb-6">{post.title}</h2>
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-64 object-cover rounded-lg mb-6"
              />
              <JSXParser
                components={{ h2: 'h2', h3: 'h3', p: 'p', ul: 'ul', li: 'li', strong: 'strong' }}
                jsx={post.content}
                renderInWrapper={false}
              />
            </motion.div>

            {/* Right Sidebar */}
            <motion.div
              className="md:w-1/4"
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: 'easeOut', delay: 0.2 }}
            >
              <div className="bg-white p-4 rounded-lg shadow-md">
      
                {otherPosts.map((item) => (
                  <div
                    key={item.id}
                    className="cursor-pointer mb-6"
                    onClick={() => navigate(item.link)}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-32 object-cover rounded mb-2"
                    />
                    <h4 className="text-lg font-semibold">{item.title}</h4>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceDetail;
